import {
  createTranslate,
  type Language,
  useLanguage,
} from "@digipost/translate";
import { useCallback } from "react";

import TRANSLATIONS from "../../assets/strings.json";

export const AVAILABLE_LANGUAGES: Language[] = ["nb", "nn", "en"];

const translator = createTranslate(
  AVAILABLE_LANGUAGES,
  TRANSLATIONS,
  (err: Error) => console.log(err),
);

export type TranslateTextKeyType = keyof typeof TRANSLATIONS;
type TranslateParamsType = Parameters<typeof translator.translate>[2];
type TranslateProvidedLanguagesType = Parameters<
  typeof translator.translate
>[3];

export type TranslateFunction = (
  textKey: TranslateTextKeyType,
  params?: TranslateParamsType,
  providedLanguages?: TranslateProvidedLanguagesType,
) => string;

export const useTranslate = (): TranslateFunction => {
  const { language } = useLanguage();
  return useCallback(
    (textKey, params, providedLanguages) =>
      translator.translate(language, textKey, params, providedLanguages),
    [language],
  );
};
